import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { AuthservicesService } from '../../../../services/authservices.service';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-detail-event',
  templateUrl: './detail-event.component.html',
  styleUrls: ['./detail-event.component.css']
})
export class DetailEventComponent implements OnInit {
  eventId
  loading = false
  productData = {}
  constructor(private route: ActivatedRoute, private authService: AuthservicesService, private router: Router) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.eventId = params["id"];
    });
    this.getEventDetails();
  }


  getEventDetails() {
    this.authService.getEventsById(this.eventId).subscribe((res: any) => {
      this.loading = true
      let data = res.data;
      this.productData = {
        id: (data._id) ? data._id : '',
        name: (data.eventName) ? data.eventName : '',
        description: (data.description) ? data.description : '',
        createdAt: (data.createdAt) ? data.createdAt : '',
        startDate: (data.validFrom) ? data.validFrom : '',
        endDate: (data.validTill) ? data.validTill : '',
        photo: (data.photo) ? data.photo : '',
        city: (data.address.city) ? data.address.city : '',
        streetAddress: (data.address.streetAddress) ? data.address.streetAddress : '',
        state: (data.address.state) ? data.address.state : '',
        country: (data.address.country) ? data.address.country : '',

      }

    },
      error => {
        console.log(error)
      })
  }



  deleteEvent() {
    this.authService.deleteEvent(this.productData['id']).subscribe((res: any) => {
      console.log(res)
      this.router.navigate(['/event-manager'])
      this.authService.successMessage(res.message, 'success')
    },
      error => {
        this.authService.successMessage(error.error.message, 'error')

      }
    )
  }

  navigate() {
    this.router.navigate(['/event-manager/update-event', this.productData['id']])
  }
}
